import React, { useEffect } from "react";
import { useParams,useSearchParams } from "react-router-dom";
import { Formik, Field, Form, useFormikContext } from "formik";
import { Loading, MultiSelect, Select, TextField } from "components/form";
import { number, required, validationWrapper } from "lib/formValidations";
import { useCore } from "store/core";
import { useWizard } from "store/wizard";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  objectFilter,
} from "lib/helpers";
import { handleSuccessMessages } from "store/auth";

const InitInfo = (props) => {
  const core = useCore();
  const wizard = useWizard();
  const { festival_id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    
   
    core.dispatch(core.getCountries());
    core.dispatch(core.getSeries());
    if (festival_id) {
      core.dispatch(core.getFestivals());
    }
   
  }, []);
  useEffect(() => {
    const type=wizard.type=='Physical'?"OnlineShop":wizard.plus_movie?"PlusVod":null;
    if(type)
    {
      core.dispatch(core.getProductCategories({type}));
    }else
    {
      core.dispatch(core.getProductCategories());
    }
   
    
  }, [wizard.type]);
  useEffect(() => {
  
    if (wizard&&wizard.product&&wizard.product.serie_id) {
      core.dispatch(core.getSeasons(wizard.product.serie_id))
    }
  }, [wizard.product]);

  if (wizard.load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Formik
        key="fromik_p_base_info"
        initialValues={
          wizard.product
            ? {
                type: wizard.type,
                country_filter_type: "All",
                ...transformTranslateServerValues(
                  objectFilter(wizard.product, [
                    "plus_movie",
                    "festival_id",
                    "country_filter_type",
                    "type",
                    "serie_id",
                    "season_id",
                    "priority",
                  ])
                ),
                product_categories:
                  wizard.product.product_categories &&
                  wizard.product.product_categories.map((i) => i.id),
                countries:
                  wizard.product.countries &&
                  wizard.product.countries.map((i) => i.id),
              }
            : {
                type: wizard.type,
                country_filter_type: "All",
                festival_id: festival_id,
                plus_movie: searchParams.get("plus_movie")||wizard.plus_movie,
                priority: 0
              }
        }
        onSubmit={async (values, { setSubmitting }) => {
          if (
            values.type == "Download" ||
            values.type == "Music"
          ) {
            handleSuccessMessages("comming soon!");
            return;
          }
          await props.submitStep(transformTranslateFromValues(values));
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values }) => (
          <>
            <div className="font-medium text-base">
              اطلاعات اولیه
              
              {values.plus_movie ? (
                <span className="bg-theme-11 rounded-sm text-white p-1 text-xs mr-3">
                  PLUS PRODUCT+
                </span>
              ) : (
                ""
              )}
            </div>
            <Form>
              <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                  {festival_id && (
                    <>
                      {core.festivalsLoad ? (
                        <Loading />
                      ) : (
                        <Field
                          label="جشنواره :"
                          name="festival_id"
                          component={Select}
                          options={core.festivals || []}
                          validate={(value) =>
                            validationWrapper(value, required, number)
                          }
                          alsoOnchange={(id) => {
                            core.dispatch(core.getSeasons(id));
                          }}
                        />
                      )}
                    </>
                  )}
                  <Field
                    label="نوع محصول :"
                    name="type"
                    component={Select}
                    validate={(value) => validationWrapper(value, required)}
                    options={[
                      { value: "Movie", label: "فیلم" },
                      { value: "Serie", label: "سریال" },
                      { value: "Music", label: "موزیک" },
                      { value: "SerieEpisode", label: "قسمتی از سریال" },
                      { value: "Screening", label: "اکران" },
                      { value: "CafeScreening", label: " اکران در کافه" },
                      { value: "Physical", label: "فیزیکی" },
                      { value: "Download", label: "دانلودی" },
                    ]}
                    alsoOnchange={(value) => {
                      wizard.dispatch(wizard.changeType(value));
                    }}
                  />
                  {values && values.type === "SerieEpisode" && (
                    <>
                      <div className="intro-y mt-2">
                        {core.seriesLoad ? (
                          <Loading />
                        ) : (
                          <Field
                            label="سریال :"
                            name="serie_id"
                            component={Select}
                            options={core.series || []}
                            validate={(value) =>
                              validationWrapper(value, required, number)
                            }
                            alsoOnchange={(id) => {
                              core.dispatch(core.getSeasons(id));
                            }}
                          />
                        )}
                      </div>
                      <div className="intro-y mt-2">
                        {core.seasonsLoad ? (
                          <Loading />
                        ) : (
                          <Field
                            label="فصل :"
                            name="season_id"
                            options={core.seasons || []}
                            component={Select}
                            validate={(value) =>
                              validationWrapper(value, required, number)
                            }
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>

                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                  <Field
                    label="فیلتر کشور :"
                    name="country_filter_type"
                    component={Select}
                    validate={(value) => validationWrapper(value, required)}
                    options={[
                      { value: "All", label: "همه" },
                      { value: "Only", label: "فقط" },
                      { value: "Except", label: "به جزء" },
                    ]}
                  />
                  {values && values.country_filter_type !== "All" && (
                    <div className="intro-y mt-2">
                      <Field
                        label="انتخاب کشور :"
                        name="countries"
                        valueOnly={true}
                        component={MultiSelect}
                        validate={(value) => validationWrapper(value, required)}
                        options={core.countries || []}
                      />
                    </div>
                    
                  )}
                </div>

                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-4">
                  {core.productCategoriesLoad ? (
                    <Loading />
                  ) : (
                    <Field
                      label="انتخاب دسته بندی :"
                      name="product_categories"
                      component={MultiSelect}
                      valueOnly={true}
                      validate={(value) => validationWrapper(value, required)}
                      options={core.productCategories || []}
                    />
                  )}
                  <div className="intro-y mt-2">
                     <Field
                    placeholder="الویت نمایش"
                    label="الویت نمایش :"
                    name="priority"
                    type={'number'}
                    component={TextField}
                    validate={(value) => validationWrapper(value)}
                  />
                    </div>
                </div>
                <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                  <button
                    className="btn btn-primary w-24 mr-2"
                    disabled={!!(isSubmitting || !dirty)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                  {wizard && wizard.mode == "update" && (
                    <button
                      className="btn btn-secondary w-24 mr-2"
                      type="button"
                      onClick={() => {
                        wizard.dispatch(wizard.next());
                      }}
                      disabled={isSubmitting}
                    >
                      بعدی
                    </button>
                  )}
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default InitInfo;
